export const vsBootstrapModuleName = "SlotTrak.Bootstrap";
